export const degreesToRadians = (degrees: number) => (degrees * Math.PI) / 180

/**
 * Safe version of Math.random that uses crypto.getRandomValues
 * @returns a random number between 0 and 1
 */
export const random = () => {
  const typedArray = new Uint8Array(1)
  const randomValue = crypto.getRandomValues(typedArray)[0]

  return randomValue / Math.pow(2, 8)
}
